<template>
    <div>
        <div class="page-title">Event Status Manage</div>
        <div class="page-box">
            <div class="page-button"> 
                  <el-button icon="el-icon-plus" @click="onAdd" type="warning"> Add </el-button>
            </div>
            <el-table
                :data="quickLinks"
                style="width: 100%;">
                    <el-table-column
                        prop="title"
                        label="Tittle">
                    </el-table-column>
                    <el-table-column
                        prop="registrationNo"
                        label="Reg. No. ">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="Type">
                        <template slot-scope="{row}">
                              <span>{{row.type | eventType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="startDate"
                        label="Application Start Day">
                        <template slot-scope="{row}">
                             <span>{{row.startDate | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="endDate"
                        label="Application End Day">
                        <template slot-scope="{row}">
                             <span>{{row.endDate | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="isExpired"
                        label="Event Expired">
                        <template slot-scope="{row}">
                            <span>{{row.isExpired | isExpiredFilters}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Action">
                        <template slot-scope="{row}">
                            <span class="action-link cursor" @click="onEdit(row.id)">Edit</span>&nbsp;
                            <span v-if="!row.isExpired" class="action-link cursor" @click="onExpired(row.id,row)">Expired</span>
                        </template>
                    </el-table-column>
            </el-table>
        </div>
        <loadingSlotDialog :centerDialogVisible="centerDialogVisible">
            <div class="dialog-title">Expire event</div>
            <div class="dialog-text">You are going to close the event of {{dialogTitle}}. When the event is turned to expired, all the application will changed to inactive which means users cannot make any changes on the applicantion.Are you sure to expire the event?</div>
            <el-button  type="warning" @click="onConfirm">Confirm</el-button>
            <el-button @click="onCancel">Cancel</el-button>
         </loadingSlotDialog>
    </div>
</template>

<script>
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import {getEventStatuses,editEventStatuses} from '@/api/admin/event-statuses'
    export default {
        components:{loadingSlotDialog},
        filters:{
            isExpiredFilters(v){
                return v ? 'Yes' : 'No'
            }
        },
        data() {
            return {
                from:{
                    title: "string", 
                    url: "string"
                },
                dialogTitle:'',
                centerDialogVisible:false,
                addCenterDialogVisible:false,
                quickLinks: [],
                itemId:0,
                row:{}
            }
        },
        created(){
            this.getEventStatuses()
        },
        methods:{
            onExpired(id,row){
               this.row = row
               this.dialogTitle = row.title
               this.itemId = id
               this.centerDialogVisible = true
            },
            onConfirm(){
                this.editEventStatuses()
            },
            onCancel(){
                this.centerDialogVisible = false
            },
            onAdd(){
                this.$router.push({path:'/admin/eventStatusManage/add'})
            },
            onEdit(id){
                 this.$router.push({path:`/admin/eventStatusManage/${id}/edit`})
            },
            editEventStatuses(){
                this.row.isExpired = true
                editEventStatuses(this.itemId,this.row).then(()=>{
                    this.getEventStatuses()
                    this.centerDialogVisible = false
                })
                
            },
            getEventStatuses(){
                getEventStatuses().then((v)=>{
                    this.quickLinks = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    padding-top: 20px;
    background-color: #fff;
    height: 100vh;
}
.page-button{
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
}
.dialog-text{
    font-size: 36px;
    color: #272727;
}
.dialog-title{
    font-size: 20px;
}
.dialog-text{
  font-size: 16px;
}
</style>